/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// document.addEventListener('variant:changed', function(event) {
// 	var variant = event.detail.variant;
//   	console.log(variant);
// });

if ($('.addtocart').length > 0) {

var toCartPosition = $('.addtocart').offset().top;
$(window).scroll(function () {
    if ($(document).scrollTop() > toCartPosition) {
        $('.addtocart').addClass("fixed-to-bottom");
    } else {
        $('.addtocart').removeClass("fixed-to-bottom");
    }
});

$('[data-disabled="true"]').on('click', function(e) {
    e.preventDefault();
    $('button.ProductForm__Item.Size').css('border-color', '#ed8380');
    setTimeout(function(){ $('button.ProductForm__Item.Size').css('border-color', '#cfcfcf '); }, 2000);
    
    if($(".Product__Info").offset()) {
      if ($(document).scrollTop() > $(".Product__Info").offset().top) {
        $('html, body').animate({
          scrollTop: $(".Product__Info").offset().top
        }, 500);
      }
    }
});

$(document).on('keyup keydown paste blur keyup', 'input[name="Engraving-Text"]', function() {
  var characters = $(this).attr('data-counter');
  if ($(this).val().length > characters) {
    $(this).val($(this).val().substr(0, characters));
  }
  var id = $(this).attr('id');
  var remaining = characters - $(this).val().length;
  $("#text_counter span").html(remaining);
  if (remaining <= 3) {
    $("#text_counter span").addClass('negative').removeClass('positive');
  } else {
    $("#text_counter span").removeClass('negative').addClass('positive');
  }
  $('.ProductForm__AddToCart').removeClass('hasEngraving');
});
}

$(document).on('keyup keydown paste blur keyup', 'input[data-counter]', function() {
  var characters = $(this).attr('data-counter');
  if ($(this).val().length > characters) {
    $(this).val($(this).val().substr(0, characters));
  }
  var id = $(this).attr('id');
  var remaining = characters - $(this).val().length;
  $("#text_counter span").html(remaining);
  if (remaining <= 3) {
    $("#text_counter span").addClass('negative').removeClass('positive');
  } else {
    $("#text_counter span").removeClass('negative').addClass('positive');
  }
});

$('.Fake_radio.eng').on('click', function() {
    $(this).addClass('checked').siblings().removeClass('checked');
    var handler = $(this).attr('data-engraving');
    if (handler == 'yes') {
        $('[data-ttoggle="engraving"]').show();
      	$('#text_counter').show();
      	
        if ($('[data-ttoggle="engraving"]').val().length > 0) {
          $('.ProductForm__AddToCart').removeClass('hasEngraving');
        } else {
          $('.ProductForm__AddToCart').addClass('hasEngraving');
        }
    } else {
        $('[data-ttoggle="engraving"]').hide();
      	$('[data-ttoggle="engraving"]').val('');
      	$('#text_counter').hide();
      	$('.ProductForm__AddToCart').removeClass('hasEngraving');
    }
});

$('.Fake_radio.gif').on('click', function() {
    $(this).addClass('checked').siblings().removeClass('checked');
    var handler = $(this).attr('data-gift');
    if (handler == 'yes') {
        $('[data-ttoggle="gift"]').css('display', 'flex');
    } else {
        $('[data-ttoggle="gift"]').css('display', 'none');
    }
});

$(document).on("click", ".ProductForm__Variants input[name='optional']", function(){
    thisRadio = $(this);
    if (thisRadio.hasClass("imChecked")) {
        thisRadio.removeClass("imChecked");
        thisRadio.prop('checked', false);
    } else { 
        thisRadio.prop('checked', true);
      	$('.ProductForm__Variants input[name="optional"]').removeClass('imChecked');
        thisRadio.addClass("imChecked");
    };
});

$(document).on("click", ".ProductForm__Variants input[name='gift']", function(){
    thisRadio = $(this);
    if (thisRadio.hasClass("imChecked")) {
        thisRadio.removeClass("imChecked");
        thisRadio.prop('checked', false);
    } else { 
        thisRadio.prop('checked', true);
      	$('.ProductForm__Variants input[name="gift"]').removeClass('imChecked');
        thisRadio.addClass("imChecked");
    };
});

$(document).on("click", ".FakeOptional input[name='optional']", function(){
    var thisRadio = $(this);
    var val = $(this).val();
    if (thisRadio.hasClass("imChecked")) {
        thisRadio.removeClass("imChecked");
        thisRadio.prop('checked', false);
    } else { 
        thisRadio.prop('checked', true);
        $('.FakeOptional input[name="optional"]').removeClass('imChecked');
        thisRadio.addClass("imChecked");
        if ($('.ProductForm__Variants input[name="optional"][value='+val+']').length) {
            $('.ProductForm__Variants input[name="optional"]').removeClass('imChecked');
            $('.ProductForm__Variants input[name="optional"][value='+val+']').prop('checked', true).addClass("imChecked");
        } else {
          	//console.log(val);
            $('.ProductForm__Variants input[name="optional"]').removeClass('imChecked');
            $('#moreOptions').prop('checked', true).val(val);
        }
    };
});


$('.Footer__Title').on('click', function() {
    //console.log($(this).attr('aria-expanded'));
    if ($(this).attr('aria-expanded') == 'true') {
        $(this).attr('aria-expanded', 'false');
        $(this).next('.Footer-Collaspe-Inner').css('overflow', 'hidden').css('height', '0px');
    } else {
        $(this).attr('aria-expanded', 'true');
        $(this).next('.Footer-Collaspe-Inner').css('overflow', 'visible').css('height', 'auto');
    }

});

if (window.matchMedia('screen and (max-width: 640px)').matches) {
  var flkty = new Flickity( '.Product__SlideshowNavScroller', {
    pageDots: false,
    groupCells: true,
    contain: true
  });
}

$('.color-swatch a').on('click', function(e) {
    e.preventDefault();
    var image_id = $(this).data('id');
    $('.ProductItem__Image.Hide[data-media-id='+image_id+']').css('opacity', 1).siblings('.Hide').css('opacity', 0);
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var image = $('#' + variant.option1 + '-' + variant.option2 + '-' + variant.option3 + '-Swatch').data('image');
  
  $('label.ColorSwatch').each(function(i, obj) {
    var val = $(this).data('tooltip');
    var position = $(this).data('position');
    if (position == 1) {
      var image = $('#' + val + '-' + variant.option2 + '-' + variant.option3 + '-Swatch').data('image');
    } else if (position == 2) {
      var image = $('#' + variant.option1 + '-' + val + '-' + variant.option3 + '-Swatch').data('image');
    } else {
      var image = $('#' + variant.option1 + '-' + variant.option2 + '-' + val + '-Swatch').data('image');
    }
    if (image) {
      $(this).css('background-image', 'url('+image+')');
    }
    
  });
});